import type {
  CambioDePlan, CambiosDePerfilProfesional, FranjaDeAtencion, NuevaCalificacion, NuevoBloqueo, NuevoSeguimiento,
  NuevoServicio,
  Plantilla, RespuestaAgenda, RespuestaBloqueo, RespuestaCancelacion, RespuestaCuentaProfesional,
  RespuestaFichaDePaciente, RespuestaHorarioDeAtencion, RespuestaMensajeria, RespuestaMetricas, RespuestaMiPerfil,
  RespuestaPacientesDelConsultorio, RespuestaServicio, RespuestaServicios, RespuestaTurnoDelConsultorio,
  RespuestaTurnosDeAgenda, RespuestaVistaPrevia, Servicio, TipoDePlantilla,
} from '@medchoice/shared';
import { buildQuery, request } from './client';

const BASE = '/consultorio';

const accion = (id: number, que: string, body?: unknown) =>
  request<RespuestaTurnoDelConsultorio>(`${BASE}/turnos/${id}/${que}`, { method: 'POST', body }).then((r) => r.turno);

export const consultorio = {
  agenda: (desde: string, hasta: string) =>
    request<RespuestaAgenda>(`${BASE}/agenda${buildQuery({ desde, hasta })}`).then((r) => r.agenda),

  bloquear: (bloqueo: NuevoBloqueo) =>
    request<RespuestaBloqueo>(`${BASE}/bloqueos`, { method: 'POST', body: bloqueo }).then((r) => r.bloqueo),

  desbloquear: (id: number) => request<void>(`${BASE}/bloqueos/${id}`, { method: 'DELETE' }),

  turnos: (desde?: string) =>
    request<RespuestaTurnosDeAgenda>(`${BASE}/turnos${buildQuery({ desde })}`).then((r) => r.turnos),

  turno: (id: number) => request<RespuestaTurnoDelConsultorio>(`${BASE}/turnos/${id}`).then((r) => r.turno),
  confirmar: (id: number) => accion(id, 'confirmacion'),
  marcarAtendido: (id: number) => accion(id, 'atencion'),
  marcarAusente: (id: number) => accion(id, 'ausencia'),
  calificar: (id: number, calificacion: NuevaCalificacion) => accion(id, 'calificacion', calificacion),
  emitirFicha: (id: number, instrucciones: string) => accion(id, 'ficha', { instrucciones }),
  anotar: (id: number, texto: string) => accion(id, 'notas', { texto }),
  programarSeguimiento: (id: number, seguimiento: NuevoSeguimiento) => accion(id, 'seguimiento', seguimiento),

  cancelar: (id: number, motivo: string) =>
    request<RespuestaCancelacion>(`${BASE}/turnos/${id}/cancelacion`, { method: 'POST', body: { motivo } })
      .then((r) => r.resultado),

  pacientes: () => request<RespuestaPacientesDelConsultorio>(`${BASE}/pacientes`).then((r) => r.pacientes),
  paciente: (id: number) => request<RespuestaFichaDePaciente>(`${BASE}/pacientes/${id}`).then((r) => r.paciente),

  metricas: (semanas: number) =>
    request<RespuestaMetricas>(`${BASE}/metricas${buildQuery({ semanas })}`).then((r) => r.metricas),

  perfil: () => request<RespuestaMiPerfil>(`${BASE}/perfil`).then((r) => r.perfil),
  actualizarPerfil: (cambios: CambiosDePerfilProfesional) =>
    request<RespuestaMiPerfil>(`${BASE}/perfil`, { method: 'PATCH', body: cambios }).then((r) => r.perfil),

  servicios: () => request<RespuestaServicios>(`${BASE}/servicios`).then((r) => r.servicios),
  agregarServicio: (servicio: NuevoServicio) =>
    request<RespuestaServicio>(`${BASE}/servicios`, { method: 'POST', body: servicio }).then((r) => r.servicio),
  editarServicio: (id: number, cambios: Partial<Omit<Servicio, 'id_servicio'>>) =>
    request<RespuestaServicio>(`${BASE}/servicios/${id}`, { method: 'PATCH', body: cambios }).then((r) => r.servicio),
  darDeBajaServicio: (id: number) =>
    request<RespuestaServicio>(`${BASE}/servicios/${id}`, { method: 'DELETE' }).then((r) => r.servicio),

  horarios: () => request<RespuestaHorarioDeAtencion>(`${BASE}/horarios`).then((r) => r.horarios),
  definirHorarios: (horarios: FranjaDeAtencion[]) =>
    request<RespuestaHorarioDeAtencion>(`${BASE}/horarios`, { method: 'PUT', body: { horarios } }).then((r) => r.horarios),

  mensajeria: () => request<RespuestaMensajeria>(`${BASE}/mensajeria`).then((r) => r.mensajeria),
  configurarMensajeria: (plantillas: Plantilla[]) =>
    request<RespuestaMensajeria>(`${BASE}/mensajeria`, { method: 'PUT', body: { plantillas } }).then((r) => r.mensajeria),
  probarMensaje: (tipo: TipoDePlantilla) =>
    request<RespuestaVistaPrevia>(`${BASE}/mensajeria/prueba`, { method: 'POST', body: { tipo } }).then((r) => r.mensaje),

  cuenta: () => request<RespuestaCuentaProfesional>(`${BASE}/cuenta`).then((r) => r.cuenta),
  contratar: (cambio: CambioDePlan) =>
    request<RespuestaCuentaProfesional>(`${BASE}/suscripcion`, { method: 'POST', body: cambio }).then((r) => r.cuenta),
};
